export * from './bookmark-button.component';
export * from './bookmark-dialog.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/map/bookmark-button/index.ts